module.exports = __webpack_public_path__ + "static/media/CTLA_1-338w.9c118314.jpg";